import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import store from "./store/store";
import { initSaviors } from "./store/reducers/list/saviorList";
import { initArcanas } from "./store/reducers/list/arcanaList";
import { initJourneys } from "./store/reducers/list/journeyList";
import { initItems } from "./store/reducers/list/itemList";
import { initSchedules } from "./store/reducers/list/scheduleList";
import { initGacha } from "./store/reducers/list/gachaList";

Promise.all([
    store.dispatch(initSaviors()),
    store.dispatch(initArcanas()),
    store.dispatch(initJourneys()),
    store.dispatch(initItems()),
    store.dispatch(initSchedules()),
    store.dispatch(initGacha()),
]).then(() => {
    const container = document.querySelector("#app");
    const root = createRoot(container);
    root.render(<App />);
});
